<template>
  <v-select
    v-model="currentGroupId"
    :items="salaryGroups"
    :label="$t('selectLabel') + '*'"
    :item-text="nameWithWage"
    :disabled="isLoading"
    :loading="isLoading"
    :rules="[$rules.isRequired]"
    return-object
    menu-props="auto"
    hide-details
    @change="changeGroup"/>
</template>

<script>
import CompanyApi from '@/api/CompanyApi'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EmployeeSettingsSalaryGroup',
  props: ['isDemo'],
  data () {
    return {
      currentGroupId: null,
      salaryGroups: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee'])
  },
  methods: {
    ...mapActions('employee', ['getEmployee']),
    nameWithWage: item => `${item.name} (${item.hourlyWage.toFixed(2)} Euro)`,

    changeGroup () {
      this.$emit('onChange', this.currentGroupId)
    },

    getAllSalaryGroupsByRole (companyId) {
      return CompanyApi.getAllSalaryGroups()
    }
  },
  i18n: {
    messages: {
      en: {
        chooseGroup: 'Assign group to employee',
        explainText: 'The salary group classifies assigns the employee a predefined hourly wage',
        save: 'Save',
        selectLabel: 'Salary group'
      },
      tr: {
        chooseGroup: 'Çalışana grup atama',
        explainText: 'Maaş grubu, çalışanlara önceden tanımlanmış saatlik bir ücret atar',
        save: 'Kaydet',
        selectLabel: 'Gelir grubu'
      },
      de: {
        chooseGroup: 'Lohngruppe zuweisen.',
        explainText: 'Die Lohngruppe definiert einen Stundenlohn für einen Mitarbeiter',
        save: 'Speicerhn',
        selectLabel: 'Lohngruppe'
      },
      ru: {
        chooseGroup: 'Назначить группу сотруднику',
        explainText: 'Группа зарплат классифицирует назначение работника к предопределенной почасовой заработной плате.',
        save: 'Сохранить',
        selectLabel: 'Зарплатная группа'
      }
    }
  },
  async mounted () {
    this.isLoading = true
    this.currentGroupId = null
    if (this.currentEmployee && !this.isDemo) {
      this.salaryGroups = await this.getAllSalaryGroupsByRole(this.currentEmployee.company_id)
      this.currentGroupId = this.salaryGroups.filter(item => this.currentEmployee.salary_group_id === item.id)[0]
    } else {
      this.salaryGroups = await this.getAllSalaryGroupsByRole()
    }
    this.currentGroupId = this.currentGroupId || null
    this.$emit('onChange', this.currentGroupId)
    this.isLoading = false
  }
}
</script>
